// eslint-disable-next-line regexp/no-obscure-range
export const namePattern = /^[A-ZÀ-ÿ][A-ZÀ-ÿ' -]{1,49}$/i
export const emailPattern = /^[\w.%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i
export const datePattern = /^[1-9]\d{3}-\d{2}-\d{2}$/ // YYYY-MM-DD format
export const mailPattern = /^[\w.%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i

export const isValidDateFormat = (val: string) => datePattern.test(val)

export function validateAgeBetweenDates(value: string, min: Date, max: Date) {
  if (!isValidDateFormat(value)) {
    return true
  }
  const date = new Date(value)
  return date >= min && date <= max
}
